module.exports = __webpack_public_path__ + "static/media/iStock-1023231622.e5cbc972.jpg";